import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { rsa2048PublicKey } from '../constants/rsa-2048-public-key';

@Injectable({
  providedIn: 'root',
})
export class EncryptionService {
  encryptRequestBody(reqBody: string) {
    const key = CryptoJS.lib.WordArray.random(16).toString();
    const iv = CryptoJS.lib.WordArray.random(8).toString();

    const encryptedBody = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(reqBody),
      CryptoJS.enc.Utf8.parse(key),
      {
        keySize: 256 / 8,
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    ).toString();

    return {
      encryptedBody,
      key,
      iv,
    };
  }

  async encryptViaRSA(data: string) {
    // Convert PEM public key to CryptoKey
    const rsaPublicKey = await window.crypto.subtle.importKey(
      'spki',
      this.pemToArrayBuffer(rsa2048PublicKey),
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['encrypt']
    );

    const encryptedData = await window.crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      rsaPublicKey,
      new TextEncoder().encode(data)
    );

    return this.arrayBufferToBase64(encryptedData);
  }

  // Helper: Convert PEM to ArrayBuffer
  pemToArrayBuffer(pem: string): ArrayBuffer {
    const b64 = pem.replace(/-----[^-]+-----/g, '').replace(/\s+/g, '');
    const binary = atob(b64);
    const buffer = new ArrayBuffer(binary.length);
    const view = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
      view[i] = binary.charCodeAt(i);
    }
    return buffer;
  }

  // Helper: Convert ArrayBuffer to Base64
  arrayBufferToBase64(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let byte of bytes) {
      binary += String.fromCharCode(byte);
    }
    return btoa(binary);
  }
}
